<template>
	<div class="container page">
		<van-nav-bar :title="$t('setting.fill_bank')" class="nav-bar" fixed placeholder>
			<template #left>
				<van-icon name="arrow-left" @click="back()" />
			</template>
		</van-nav-bar>

		<van-tabs v-model="bindType" sticky color="#7e5678" title-active-color="#7e5678" class="custom-tabs">
			<van-tab :title="$t('setting.bank_card')" name="bank"></van-tab>
			<van-tab :title="$t('setting.crypto_wallet')" name="usdt"></van-tab>
			<van-tab :title="$t('paypal')" name="paypal"></van-tab>
			<van-tab :title="$t('Cash App')" name="cashApp"></van-tab>
		</van-tabs>

		<div class="main-box">
			<div class="label">{{$t("setting.fill_bank_tip")}}</div>

			<div class="form-card">
				<van-cell-group :border="false">

					<template v-if="bindType === 'bank'">
						<van-field v-model="username" :label="$t('setting.username')" :placeholder="$t('setting.username_place')" />
						<van-field v-model="bank" :label="$t('setting.band_name')" :placeholder="$t('setting.band_name_tip')" />
						<van-field v-model="bankid" :label="$t('setting.band_account')" type="text"
							:placeholder="$t('setting.band_account_tip')" :formatter="formatter" />
					</template>

          <template v-if="bindType === 'usdt'">
						<van-field
							readonly
							clickable
							:label="$t('setting.wallet_type')"
							:value="walletType"
							:placeholder="$t('setting.select_wallet_type')"
							@click="showWalletPicker = true"
						>
							<template #right-icon>
								<van-icon name="arrow-down" color="#ee0a24" v-if="showWalletPicker" />
								<van-icon name="arrow-down" v-else />
							</template>
						</van-field>

						<van-field v-model="usdt_address" :label="$t('setting.wallet_address')" :placeholder="$t('setting.enter_wallet_address')" />
					</template>

          <template v-if="bindType === 'paypal'">

						<van-field v-model="paypal_account" :label="$t('setting.receiver')" :placeholder="$t('setting.receiver_place')" />
					</template>

          <template v-if="bindType === 'cashApp'">

						<van-field v-model="cash_app_account" :label="$t('setting.receiver')" :placeholder="$t('setting.receiver_place')" />
					</template>

				</van-cell-group>
			</div>

			<p class="warn-text">
				<van-icon name="info-o" class="icon" />
				{{$t("setting.bank_warn")}}
			</p>
		</div>

		<van-button class="bindCard" type="default" @click="bindCard()">{{$t("setting.bank_ok")}}</van-button>

		<van-popup v-model="showWalletPicker" round position="bottom">
			<van-picker
				show-toolbar
				:title="$t('setting.select_wallet_type')"
				:columns="walletColumns"
				@confirm="onWalletConfirm"
				@cancel="showWalletPicker = false"
			/>
		</van-popup>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				bindType: 'bank',

				// 虚拟货币相关
				usdt_address: "",
				walletType: "USDT(TRC20)",
				showWalletPicker: false,
				walletColumns: [
					'USDC(TRC20)',
					'USDT(ERC20)',
					'USDT(TRC20)',
					'ETH',
					'BTC'
				],

        paypal_account:"",
        cash_app_account:"",

				// 银行卡相关
				userInfo: {},
				bankid: "",
				username: "",
				bank: "",
				bankfenhang: '',
				fhnumber: ""
			};
		},
		methods: {
			formatter(value) {
				return value.replace(/[^a-zA-Z0-9]/g, '');
			},
			back() {
				return window.history.back();
			},
			onWalletConfirm(value) {
				this.walletType = value;
				this.showWalletPicker = false;
			},
			bindCard() {
				let postData = {};
				let apiUrl = '';

				if (this.bindType === 'bank') {
					// 银行卡逻辑：需要校验 username
					if (this.username === "") {
						this.$toast(this.$t("setting.username_place"));
						return;
					}
					if (!this.bank || !this.bankid) {
						this.$toast.fail(this.$t("setting.band_name_tip"));
						return;
					}
					postData = {
            type:1,
						username: this.username, // 只有银行卡提交姓名
						bankid: this.bankid,
						bank: this.bank,
						// bankfenhang: this.bankfenhang,
						// fhnumber: this.fhnumber
					};
					apiUrl = 'user_set_bank';
				}
        else if(this.bindType === 'usdt') {
					// 虚拟货币逻辑：不校验也不提交 username
					if (!this.usdt_address) {
						this.$toast.fail(this.$t("setting.enter_wallet_address"));
						return;
					}
					postData = {
            type:2,
            network: this.walletType,
						address: this.usdt_address
					};
					apiUrl = 'user_set_bank';
				}
        else if(this.bindType === 'paypal') {
					if (!this.paypal_account) {
						this.$toast.fail(this.$t("setting.receiver_place"));
						return;
					}
					postData = {
            type:3,
            account: this.paypal_account
					};
					apiUrl = 'user_set_bank';
				}
        else if(this.bindType === 'cashApp') {
					if (!this.cash_app_account) {
						this.$toast.fail(this.$t("setting.receiver_place"));
						return;
					}
					postData = {
            type:4,
            account: this.cash_app_account
					};
					apiUrl = 'user_set_bank';
				}

				this.$http({
					method: 'post',
					data: postData,
					url: apiUrl
				}).then(res => {
					if (res.code === 200) {
						this.$toast.success(res.msg || 'Success');
						this.$router.push('/Mine');
					} else {
						this.$toast.fail(res.msg);
					}
				}).catch(() => {
					this.$toast.fail(this.$t("setting.network_error"));
				});
			},
			getUserInfo() {
				this.$http({ method: 'get', url: 'user_info' }).then(res => {
					if (res.code === 200) this.userInfo = res.data;
				});
			}
		},
		created() {
			if (!localStorage.getItem('token')) {
				this.$router.push('/Login');
			} else {
				this.getUserInfo();
			}
		}
	};
</script>

<style lang='less' scoped>
	@import "../../assets/css/base.css";

	/* 页面底层灰底，衬托卡片 */
	.container {
		min-height: 100vh;
		background-color: #f7f8fa;
	}

	/* 统一导航栏样式 */
	::v-deep .van-nav-bar--fixed {
		background: linear-gradient(90deg, #7e5678, #a17e96) !important;
	}
	.nav-bar {
		::v-deep .van-nav-bar__title { color: #fff !important; font-weight: 500; font-size: 32px; }
		::v-deep .van-icon { font-size: 40px !important; color: #fff !important; }
	}

	.custom-tabs {
		background: #fff;
		box-shadow: 0 2px 8px rgba(0,0,0,0.04);
	}

	.main-box {
		padding-top: 30px;
	}

	.main-box .label {
		padding: 0 32px 20px;
		font-size: 28px;
		color: #969799;
	}

	/* 卡片式表单容器 */
	.form-card {
		margin: 0 24px;
		border-radius: 16px;
		background: #fff;
		box-shadow: 0 4px 16px rgba(0, 0, 0, 0.04);
		overflow: hidden;

		.van-cell {
			font-size: 30px;
			padding: 24px 32px;
			align-items: center;

			&::after {
				left: 32px;
				right: 32px;
			}
		}

		::v-deep .van-field__label {
			color: #323233;
			font-weight: 500;
		}
	}

	.warn-text {
		padding: 30px 32px 0;
		font-size: 24px;
		color: #ee0a24;
		display: flex;
		align-items: flex-start;
		line-height: 1.4;

		.icon {
			margin-right: 8px;
			margin-top: 4px;
			font-size: 28px;
		}
	}

	/* 按钮优化 */
	.bindCard {
		width: calc(100% - 48px);
		margin: 60px 24px 40px;
		height: 88px;
		border-radius: 44px;
		color: #fff;
		font-size: 32px;
		font-weight: 600;
		border: none;
		background: linear-gradient(90deg, #7e5678, #a17e96);
		box-shadow: 0 8px 20px rgba(126, 86, 120, 0.25);
		transition: all 0.2s;

		&:active {
			transform: scale(0.97);
			opacity: 0.9;
		}
	}

	::v-deep .van-field__right-icon .van-icon {
		font-size: 32px;
	}
</style>
